import { HttpBackend, HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, startWith } from 'rxjs';


@Component({
  selector: 'app-pool-point-modal',
  templateUrl: './pool-point-modal.component.html',
  styleUrls: ['./pool-point-modal.component.scss']
})
export class PoolPointModalComponent implements OnInit {
  modalTitle: string;
  modalMessage: string;
  poolPointUuid!: string;
  clientUuid!: string;
  poolForm: FormGroup;
  clientForm: FormGroup;
  storeForm: FormGroup;
  storeUuid!: string;

  filteredShipperList: Observable<string[]> | undefined;
  filteredConsigneeList: Observable<string[]> | undefined;
  filteredCarrierList: Observable<string[]> | undefined;

  typeListCountry: string[] = [
    "Canada",
    "United States"
  ]
  shipperList: string[] = ['Select Shipper Contact'];
  shipperAddresses: string[] = ['Select Shipper Address'];
  shipperListObj!: any[];

  consigneeList: string[] = ['Select Consignee Contact'];;
  consigneeAddresses: string[] = ['Select Consignee Address'];
  consigneeListObj!: any[];

  carrierList: string[] = ['Select Carrier Contact'];;
  carrierAddresses: string[] = ['Select Carrier Address'];
  carrierListObj!: any[];

  constructor(
    public dialogRef: MatDialogRef<PoolPointModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private http: HttpClient
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;
    this.poolPointUuid = data.data.poolPointUuid;
    this.clientUuid = data.data.clientUuid;
    this.storeUuid = data.data.storeUuid;

    this.poolForm = this.formBuilder.group({
      pool_point_name: [''],
      new_contact_control: [''],
      pool_point_contact_uuid: [''],
      pool_point_address_uuid: [''],
    });

    this.clientForm = this.formBuilder.group({
      pool_point_client_name: [''],
      new_contact_control: [''],
      pool_point_uuid: [''],
      pool_point_client_contact_uuid: [''],
    });

    this.storeForm = this.formBuilder.group({
      pool_point_store_number: [''],
      new_contact_control: [''],
      pool_point_uuid: [''],
      pool_point_client_uuid: [''],
      pool_point_store_contact_uuid: [''],
      pool_point_store_address_uuid: [''],
    });
  }
  //Filter shipper list
  filterShipperList(name: string) {
    return this.shipperList.filter(shipperList =>
      shipperList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  shipperAddressList(): Observable<string[]> {
    if (this.shipper_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.shipper_selected_uuid}`)
        .pipe(
          map(response => {
            this.poolForm.get('pool_point_contact_uuid')?.setValue(this.shipper_selected_uuid);
            this.poolForm.get('pool_point_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
            this.clientForm.get('pool_point_client_contact_uuid')?.setValue(this.shipper_selected_uuid);
            this.clientForm.get('pool_point_uuid')?.setValue(this.poolPointUuid);
            // this.new_shipper_info.get('shipper_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            // console.log('shipper_address_uuid: ' + this.new_shipper_info.get('shipper_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }
  //Filter consignee list
  filterConsigneeList(name: string) {
    return this.consigneeList.filter(consigneeList =>
      consigneeList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  consigneeAddressList(): Observable<string[]> {
    if (this.consignee_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.consignee_selected_uuid}`)
        .pipe(
          map(response => {
            this.poolForm.get('pool_point_contact_uuid')?.setValue(this.consignee_selected_uuid);
            this.poolForm.get('pool_point_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
            this.storeForm.get('pool_point_store_contact_uuid')?.setValue(this.consignee_selected_uuid);
            this.storeForm.get('pool_point_store_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
            this.storeForm.get('pool_point_uuid')?.setValue(this.poolPointUuid);
            this.storeForm.get('pool_point_client_uuid')?.setValue(this.clientUuid);
            // this.new_shipper_info.get('shipper_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            // console.log('shipper_address_uuid: ' + this.new_shipper_info.get('shipper_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }
  //Filter carrier list
  filterCarrierList(name: string) {
    return this.carrierList.filter(carrierList =>
      carrierList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  carrierAddressList(): Observable<string[]> {
    if (this.carrier_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.carrier_selected_uuid}`)
        .pipe(
          map(response => {
            this.poolForm.get('pool_point_contact_uuid')?.setValue(this.carrier_selected_uuid);
            this.poolForm.get('pool_point_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
            // this.new_shipper_info.get('shipper_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            // console.log('shipper_address_uuid: ' + this.new_shipper_info.get('shipper_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }
  shipper_selected_uuid!: string;
  consignee_selected_uuid!: string;
  carrier_selected_uuid!: string;
  ngOnInit(): void {

    this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=carrier_contact_list').subscribe(response => {
      console.log('carrier:', response);
      this.carrierListObj = response;
      this.carrierList = this.carrierListObj.map(item => item.label);
      this.filteredCarrierList = this.poolForm.get('new_contact_control')?.valueChanges
        .pipe(
          startWith(''),
          map(carrierList => carrierList ? this.filterCarrierList(carrierList) : this.carrierList.slice())
        );
    })
    this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.carrierListObj?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.carrierListObj && index !== undefined) {
        this.carrier_selected_uuid = this.carrierListObj[index]?.value;
        // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.carrier_selected_uuid) {
          this.carrierAddressList().subscribe(data => {
            this.carrierAddresses = data;
          });
        }
      }
    });

    this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=shipper_contact_list').subscribe(response => {
      console.log('shippers:', response);
      this.shipperListObj = response;
      this.shipperList = this.shipperListObj.map(item => item.label);
      if (this.modalTitle === 'Create New Pool Point') {
        this.filteredShipperList = this.poolForm.get('new_contact_control')?.valueChanges
          .pipe(
            startWith(''),
            map(shipperList => shipperList ? this.filterShipperList(shipperList) : this.shipperList.slice())
          );
      } else {
        this.filteredShipperList = this.clientForm.get('new_contact_control')?.valueChanges
          .pipe(
            startWith(''),
            map(shipperList => shipperList ? this.filterShipperList(shipperList) : this.shipperList.slice())
          );
      }
    })

    this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.shipperListObj?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.shipperListObj && index !== undefined) {
        this.shipper_selected_uuid = this.shipperListObj[index]?.value;
        // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.shipper_selected_uuid) {
          // console.log('array of addresses:', this.)
          this.shipperAddressList().subscribe(data => {
            this.shipperAddresses = data;
          });
        }
      }
    });

    this.clientForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.shipperListObj?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.shipperListObj && index !== undefined) {
        this.shipper_selected_uuid = this.shipperListObj[index]?.value;
        // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.shipper_selected_uuid) {
          this.shipperAddressList().subscribe(data => {
            this.shipperAddresses = data;
          });
        }
      }
    });

    this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=consignee_contact_list').subscribe(response => {
      console.log('consignees:', response);
      this.consigneeListObj = response;
      this.consigneeList = this.consigneeListObj.map(item => item.label);
      if (this.modalTitle === 'Create New Pool Point') {
        this.filteredConsigneeList = this.poolForm.get('new_contact_control')?.valueChanges
          .pipe(
            startWith(''),
            map(consigneeList => consigneeList ? this.filterConsigneeList(consigneeList) : this.consigneeList.slice())
          );
      } else {
        this.filteredConsigneeList = this.storeForm.get('new_contact_control')?.valueChanges
          .pipe(
            startWith(''),
            map(consigneeList => consigneeList ? this.filterConsigneeList(consigneeList) : this.consigneeList.slice())
          );
      }
    })
    this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.consigneeListObj?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.consigneeListObj && index !== undefined) {
        this.consignee_selected_uuid = this.consigneeListObj[index]?.value;
        // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.consignee_selected_uuid) {
          this.consigneeAddressList().subscribe(data => {
            this.consigneeAddresses = data;
          });
        }
      }
    });

    this.storeForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.consigneeListObj?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.consigneeListObj && index !== undefined) {
        this.consignee_selected_uuid = this.consigneeListObj[index]?.value;
        // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.consignee_selected_uuid) {
          this.consigneeAddressList().subscribe(data => {
            this.consigneeAddresses = data;
          });
        }
      }
    });

    // if(this.modalTitle == 'Create New Pool Point') {
    //   this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=shipper_contact_list').subscribe(response => {
    //   console.log('shippers:', response);
    //   this.shipperListObj = response;
    //   this.shipperList = this.shipperListObj.map(item => item.label);  
    //   this.filteredShipperList = this.poolForm.get('new_contact_control')?.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(shipperList => shipperList ? this.filterShipperList(shipperList) : this.shipperList.slice())
    //   );
    // })

    // this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
    //   const index = this.shipperListObj?.findIndex((item: any) => item.label === data);
    //   if (index !== -1 && this.shipperListObj && index !== undefined) {
    //     this.shipper_selected_uuid = this.shipperListObj[index]?.value;
    //     // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
    //     // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
    //     if (this.shipper_selected_uuid) {
    //       this.shipperAddressList().subscribe(data => {
    //         this.shipperAddresses = data;
    //       });
    //     }
    //   }
    // });
    // }
    // else if(this.modalTitle == 'Create New Client') {
    //   this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=shipper_contact_list').subscribe(response => {
    //   console.log('shippers:', response);
    //   this.shipperListObj = response;
    //   this.shipperList = this.shipperListObj.map(item => item.label); 
    //   this.filteredShipperList = this.poolForm.get('new_contact_control')?.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(shipperList => shipperList ? this.filterShipperList(shipperList) : this.shipperList.slice())
    //   );
    // })
    // this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
    //   const index = this.shipperListObj?.findIndex((item: any) => item.label === data);
    //   if (index !== -1 && this.shipperListObj && index !== undefined) {
    //     this.shipper_selected_uuid = this.shipperListObj[index]?.value;
    //     // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
    //     // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
    //     if (this.shipper_selected_uuid) {
    //       this.shipperAddressList().subscribe(data => {
    //         this.shipperAddresses = data;
    //       });
    //     }
    //   }
    // });
    // }
    // else {
    //   this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=consignee_contact_list').subscribe(response => {
    //   console.log('consignees:', response);
    //   this.consigneeListObj = response;
    //   this.consigneeList = this.consigneeListObj.map(item => item.label);  
    //   this.filteredConsigneeList = this.poolForm.get('new_contact_control')?.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(consigneeList => consigneeList ? this.filterShipperList(consigneeList) : this.consigneeList.slice())
    //   );
    // })
    // this.poolForm.get('new_contact_control')?.valueChanges.subscribe((data) => {
    //   const index = this.consigneeListObj?.findIndex((item: any) => item.label === data);
    //   if (index !== -1 && this.consigneeListObj && index !== undefined) {
    //     this.consignee_selected_uuid = this.consigneeListObj[index]?.value;
    //     // this.poolForm.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
    //     // console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
    //     if (this.consignee_selected_uuid) {
    //       this.consigneeAddressList().subscribe(data => {
    //         this.consigneeAddresses = data;
    //       });
    //     }
    //   }
    // });
    // }
  }

  createPoolPoint() {
    const url = "/api/pool_points/pool_points.php/?table=pool_points"
    console.log(this.poolForm.value)
    const postData = this.poolForm.value;
    this.http.post(url, postData).subscribe(response => {
      console.log('Post Data:', response);
    })
  }

  createClient() {
    const url = "/api/pool_points/pool_points.php/?table=pool_point_clients"
    console.log(this.clientForm.value)
    const postData = this.clientForm.value;
    this.http.post(url, postData).subscribe(response => {
      console.log('Post Data:', response);
    })
  }

  createStore() {
    const url = "/api/pool_points/pool_points.php/?table=pool_point_stores"
    console.log(this.storeForm.value)
    const postData = this.storeForm.value;
    this.http.post(url, postData).subscribe(response => {
      console.log('Post Data:', response);
    })
  }

  onSelectionShipper(event: any) {
    var selectedObj: any;
    if (this.selectedContactType == 'shipper') {
      selectedObj = this.shipperListObj.find((obj: any) => obj.label === event.value);
    }
    else if (this.selectedContactType == 'consignee') {
      selectedObj = this.consigneeListObj.find((obj: any) => obj.label === event.value);
    }
    else {
      selectedObj = this.carrierListObj.find((obj: any) => obj.label === event.value);
    }
    console.log('shipper value:', event.value);
    this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${selectedObj.value}`).subscribe(response => {
      console.log(response)
      this.shipperAddresses = response[0].addresses.map((item: any) => item.address + ' - ' + item.region + ' - ' + item.country + ' - ' + item.postal_code);
      this.consigneeAddresses = response[0].addresses.map((item: any) => item.address + ' - ' + item.region + ' - ' + item.country + ' - ' + item.postal_code);
      this.carrierAddresses = response[0].addresses.map((item: any) => item.address + ' - ' + item.region + ' - ' + item.country + ' - ' + item.postal_code);
      this.poolForm.get('pool_point_contact_uuid')?.setValue(selectedObj.value);
      this.poolForm.get('pool_point_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
      this.clientForm.get('pool_point_client_contact_uuid')?.setValue(selectedObj.value);
      this.clientForm.get('pool_point_uuid')?.setValue(this.poolPointUuid);
    })
  }

  onSelectionConsignee(event: any) {
    const selectedConsignee: any = this.consigneeListObj.find((obj: any) => obj.label === event.value);
    console.log('consignee value:', event.value);
    this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${selectedConsignee.value}`).subscribe(response => {
      console.log(response)
      this.consigneeAddresses = response[0].addresses.map((item: any) => item.address + ' - ' + item.region + ' - ' + item.country + ' - ' + item.postal_code);
      this.storeForm.get('pool_point_client_uuid')?.setValue(this.clientUuid);
      this.storeForm.get('pool_point_store_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid);
      this.storeForm.get('pool_point_store_contact_uuid')?.setValue(selectedConsignee.value);
      this.storeForm.get('pool_point_uuid')?.setValue(this.poolPointUuid);
    })
  }

  onSelectionShipperAddress(event: any) {
    // this.poolForm.get('pool_point_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
  }

  selectedContactType: string = 'shipper';
  onToggleChange(event: any): void {
    this.selectedContactType = event.value;
    this.poolForm.get('new_contact_control')?.setValue('');
  }

  switchClient() {
    // create URLS to send POST data to
    const pool_point_client_url = `/api/pool_points/pool_points.php/?table=pool_point_clients&uuid=${this.clientUuid}`;

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      pool_point_client_contact_uuid: this.clientForm.get('pool_point_client_contact_uuid')?.value
    }
    this.http.post<any>(pool_point_client_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
    // console.log('new client contact', this.clientForm.get('pool_point_client_contact_uuid')?.value);
  }

  switchStore() {
    // create URLS to send POST data to
    const pool_point_address_url = `/api/pool_points/pool_points.php/?table=pool_point_stores&uuid=${this.storeUuid}`;

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      pool_point_store_contact_uuid: this.storeForm.get('pool_point_store_contact_uuid')?.value,
      pool_point_store_address_uuid: this.storeForm.get('pool_point_store_address_uuid')?.value,
    }
    this.http.post<any>(pool_point_address_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
    console.log('new store contact', postData);
  }

  switchPool() {
    const pool_point_address_url = `/api/pool_points/pool_points.php/?table=pool_points&uuid=${this.poolPointUuid}`;

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      pool_point_contact_uuid: this.poolForm.get('pool_point_contact_uuid')?.value,
      pool_point_address_uuid: this.poolForm.get('pool_point_address_uuid')?.value,
    }
    this.http.post<any>(pool_point_address_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
    console.log('new store contact', postData);
  }

  closeModal() {
    this.dialogRef.close();
  }
}
